module.exports = __webpack_public_path__ + "img/footer-nudgd.d558bbb3.png";